import { cn } from '#app/utils/misc.tsx'

/**
 * Use CardShape to create a card with the correct aspect ratio.
 * This helps ensure all cards across the application are
 * visually consistent.
 *
 * The height or width of this element must be set, otherwise the aspect-ratio css will be ignored.
 */
export const CardShape = ({
	children,
	className,
}: {
	children?: React.ReactNode
	className: string | undefined
}) => {
	return (
		<div className={cn('aspect-w-4 aspect-h-5 grid', className)}>
			{children}
		</div>
	)
}
